import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

export type IGetUserByTrackCodeRepoResponse = IRepoResponse<200, { id: number; fullName: string }> | IRepoResponse<400 | 500, string>;

export type IGetUserByTrackCodeRepo = IRepo<[string], IGetUserByTrackCodeRepoResponse>;

export const GetUserByTrackCodeRepoType = Symbol.for('GetUserByTrackCodeRepo');

@bind(GetUserByTrackCodeRepoType)
export class GetUserByTrackCodeRepo implements IGetUserByTrackCodeRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: number | string) {
    try {
      const result = await this.httpClient.post({ url: urlMaker('/api/admin/client/track_code', { track_code: id }) });

      if (result.status === 200) {
        const data = result.data.data;

        return {
          status: 200 as 200,
          response: { id: data.id, fullName: data.user_name },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
